"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseMonthRangeInput = void 0;
var react_1 = __importStar(require("react"));
var __1 = require("..");
var i18n_1 = require("../../i18n");
var styles_1 = require("../../styles");
var react_2 = require("../../util/react");
var Icon_1 = require("../Icon");
var MonthInput_1 = require("../MonthField/MonthInput");
var util_1 = require("./util");
function BaseMonthRangeInput(props) {
    var clearable = props.clearable, disabled = props.disabled, divRef = props.divRef, icon = props.icon, initialInputRef = props.initialInputRef, finalInputRef = props.finalInputRef, minMonth = props.minMonth, maxMonth = props.maxMonth, name = props.name, onChange = props.onChange, onIconClick = props.onIconClick, onInputOnFocus = props.onInputOnFocus, rangeSeparator = props.rangeSeparator, value = props.value, style = props.style, rest = __rest(props, ["clearable", "disabled", "divRef", "icon", "initialInputRef", "finalInputRef", "minMonth", "maxMonth", "name", "onChange", "onIconClick", "onInputOnFocus", "rangeSeparator", "value", "style"]);
    var firstFieldRef = react_1.useRef();
    var secondFieldRef = react_1.useRef();
    var _a = styles_1.useStyles(createStyles, disabled), classes = _a.classes, css = _a.css;
    var className = css(classes.div, props.invalid && classes.invalid, props.style);
    var handleMinmaxMonth = function (month) {
        if (minMonth && maxMonth) {
            return month && util_1.isGreaterOrEqualThan(month, minMonth) && util_1.isLessOrEqualThan(month, maxMonth) ? month : undefined;
        }
        else if (minMonth) {
            return month && util_1.isGreaterOrEqualThan(month, minMonth) ? month : undefined;
        }
        else if (maxMonth) {
            return month && util_1.isLessOrEqualThan(month, maxMonth) ? month : undefined;
        }
        else {
            return month;
        }
    };
    var onChangeStart = function (refMonth) {
        var start = handleMinmaxMonth(refMonth);
        var end = (value === null || value === void 0 ? void 0 : value.start) && (value === null || value === void 0 ? void 0 : value.end) && start && util_1.isGreaterThan(start, value === null || value === void 0 ? void 0 : value.end) ? undefined : value === null || value === void 0 ? void 0 : value.end;
        var aux = {
            start: start,
            end: end,
        };
        onChange && onChange(aux);
        if (start) {
            secondFieldRef.current.focus();
        }
    };
    var onChangeFinal = function (refMonth) {
        var auxFinalMonth = handleMinmaxMonth(refMonth);
        var start = (value === null || value === void 0 ? void 0 : value.start) && (value === null || value === void 0 ? void 0 : value.end) && auxFinalMonth && util_1.isLessThan(auxFinalMonth, value === null || value === void 0 ? void 0 : value.start)
            ? auxFinalMonth
            : value === null || value === void 0 ? void 0 : value.start;
        var end = (value === null || value === void 0 ? void 0 : value.start) && (value === null || value === void 0 ? void 0 : value.end) && auxFinalMonth && util_1.isLessThan(auxFinalMonth, value === null || value === void 0 ? void 0 : value.start) ? undefined : auxFinalMonth;
        var aux = {
            start: start,
            end: end,
        };
        onChange && onChange(aux);
    };
    var onClearStart = function () {
        var aux = { start: undefined, end: value.end };
        onChange && onChange(aux);
        firstFieldRef.current.focus();
    };
    var onClearFinal = function () {
        var aux = { start: value.start, end: undefined };
        onChange && onChange(aux);
        secondFieldRef.current.focus();
    };
    var defaultHandleOnClick = function () { return firstFieldRef.current.focus(); };
    var onInputOnFocusInicial = function () { return onInputOnFocus && onInputOnFocus(1); };
    var onInputOnFocusFinal = function () { return onInputOnFocus && onInputOnFocus(2); };
    var handleIconClick = onIconClick ? onIconClick : defaultHandleOnClick;
    var locale = i18n_1.useLocale();
    return (react_1.default.createElement("div", { ref: divRef },
        react_1.default.createElement("div", { className: className },
            react_1.default.createElement("div", { className: classes.fieldWrapper },
                react_1.default.createElement(MonthInput_1.MonthInput, __assign({ clearable: clearable, name: name ? name + ".start" : 'start', disabled: disabled, inputRef: react_2.composeRefs(firstFieldRef, initialInputRef), onChange: onChangeStart, onClear: onClearStart, placeholder: locale.monthInput.placeholder, style: classes.monthField, value: value === null || value === void 0 ? void 0 : value.start, onFocus: onInputOnFocusInicial }, rest))),
            react_1.default.createElement("span", { className: classes.spanWrapper },
                react_1.default.createElement("strong", null, rangeSeparator ? rangeSeparator : locale.dateRangeField.separator)),
            react_1.default.createElement("div", { className: classes.fieldWrapper },
                react_1.default.createElement(MonthInput_1.MonthInput, __assign({ clearable: clearable, name: name ? name + ".end" : 'end', disabled: disabled, inputRef: react_2.composeRefs(secondFieldRef, finalInputRef), onChange: onChangeFinal, onClear: onClearFinal, placeholder: locale.monthInput.placeholder, style: classes.monthField, value: value === null || value === void 0 ? void 0 : value.end, onFocus: onInputOnFocusFinal }, rest))),
            react_1.default.createElement("span", { className: classes.iconWrapper },
                react_1.default.createElement(__1.Button, { size: 'small', skin: 'ghost', tabIndex: -1, onClick: handleIconClick, style: classes.icon, disabled: disabled },
                    react_1.default.createElement(Icon_1.Icon, { icon: icon }))))));
}
exports.BaseMonthRangeInput = BaseMonthRangeInput;
BaseMonthRangeInput.defaultProps = {
    icon: 'calendarOutline',
    clearable: true,
};
var createStyles = function (theme, disabled) {
    var divStyle = createBaseDivStyle(theme);
    return {
        div: __assign(__assign({}, divStyle.base), { ':not(:disabled):hover': divStyle.hover, ':not(:disabled):active': divStyle.active, ':focus-within': {
                ':not(:disabled)': divStyle.focus,
            }, background: disabled && theme.pallete.surface.background }),
        invalid: divStyle.invalid,
        spanWrapper: {
            alignItems: 'center',
            background: 'transparent',
            color: disabled && theme.pallete.text.disabled,
            cursor: 'default',
            display: 'flex',
            position: 'relative',
        },
        monthField: {
            border: 'none',
            '::placeholder': {
                color: theme.pallete.text.secondary,
            },
            '&:focus': {
                boxShadow: 'none !important',
            },
        },
        fieldWrapper: {
            flex: 1,
        },
        icon: {
            padding: 'calc(0.25rem - 2px) calc(0.5rem - 1px)',
            borderRadius: 'inherit',
            '&:focus': {
                boxShadow: 'none',
            },
        },
        iconWrapper: {
            backgroundColor: theme.pallete.gray.c90,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '2.5rem',
            borderTopRightRadius: 1,
            borderBottomRightRadius: 1,
        },
    };
};
var createBaseDivStyle = function (theme) { return ({
    base: {
        backgroundColor: theme.pallete.surface.main,
        border: '1px solid' + theme.pallete.gray.c70,
        borderRadius: theme.radius.input,
        cursor: 'default',
        display: 'flex',
        position: 'relative',
        transition: 'box-shadow .2s ease',
        '&:required': {
            boxShadow: 'none',
        },
    },
    active: {
        borderColor: theme.pallete.primary.main,
        boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.09)',
    },
    focus: {
        boxShadow: styles_1.focusBoxShadow(theme),
        outline: 'none',
    },
    hover: {
        borderColor: theme.pallete.gray.c60,
    },
    invalid: {
        border: 'solid 1px ' + theme.pallete.status.danger.main,
        '&:focus-within': {
            ':not(:disabled)': {
                border: 'solid 1px ' + theme.pallete.gray.c80,
                boxShadow: styles_1.focusBoxShadow(theme, 'danger'),
            },
        },
    },
}); };
//# sourceMappingURL=BaseMonthRangeInput.js.map